import {
    GET_RELEASE_STATUS,
  } from "../actions/release";

  const defVal = {
    releaseMess: '',
  };
  
  export default (state = defVal, action) => {
    switch (action.type) {
      case GET_RELEASE_STATUS:
        return Object.assign({}, state, {
          releaseMess: action.releaseMess
        });
      default:
        return state;
    }
  };
  